export default "/assets/images/chart-sm-04.svg?82a6d5e625964c068a8e860bcadb19e3";